import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import ReactModal from 'react-modal'
import "../PaidPopup.css"
import VerifyPopHeader from "./VerifyPopHeader";
import Email from "./images/emailbox.svg"
import Button from "../Button";
import { P } from "../CommonStyle";
import EmailField from "./EmailField";
import Tick from "./images/verify.svg"
import VerifyCode from "./VerifyCode";
import { ICSuserTrack, checkPublicDomain, getUserGeolocationInfo } from "../Common";
import Blocker from "../Blocker/Blocker";
import ErrorMassage from "../Band/Error.js";
import Cookies from "js-cookie";

const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 22px;
    flex-direction: row;
    gap: 12px;
`
const TextWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: 4px;
    margin-top: 12px;
`
const TalkUs = styled.a`
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    color: #2970B1;
    cursor: pointer;

    &:hover{
        color: #15436d;
    }
`

export default function VerifyEmailAddress(props) {
  const [isOpen, setIsOpen] = useState(true);
  var Url = process.env.NEXT_PUBLIC_SERVER_NAME_URL + window.location.pathname;

  const handleClose = () => {
    if (!Cookies.get("sesEmail") || !Cookies.get("sesUserId")) {
      ICSuserTrack("", "Clicked on close button", Url, "CES 2024 Report", "", Cookies.get("accessid"))
    } else {
      ICSuserTrack(Cookies.get("sesEmail"), "Clicked on close button", Url, "CES 2024 Report", Cookies.get("sesUserId"), Cookies.get("accessid"))
    }
    props.setShowVerifyEmail(false);
    props.setProceedForVerification(false);
  };
  const [checkEmailEntered, setCheckEmailEntered] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [verifyError, setVerifyError] = useState(null);
  const [verifySuccess, setVerifySuccess] = useState(null);
  const [handleErrorMsgCES, setHandleErrorMsgCES] = useState(null);
  const [handleSuccMsgCES, setHandleSuccMsgCES] = useState(null);

  useEffect(() => {
    if (verifyError != null) {
      setTimeout(() => {
        setVerifyError(null);
      }, 5000);
    }
    if (verifySuccess != null) {
      setTimeout(() => {
        setVerifySuccess(null);
      }, 5000);
    }
  }, [verifyError, verifySuccess]);


  const isValidEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const handleVerifyEmailProceed = () => {
    if (!Cookies.get("sesEmail") || !Cookies.get("sesUserId")) {
      ICSuserTrack("", "Clicked on Proceed button", Url, "CES 2024 Report", "", Cookies.get("accessid"))
    } else {
      ICSuserTrack(Cookies.get("sesEmail"), "Clicked on Proceed button", Url, "CES 2024 Report", Cookies.get("sesUserId"), Cookies.get("accessid"))
    }


    if (!props.enteredEmail.trim()) {
      setCheckEmailEntered('Enter a valid work email');
      return;
    } else if (!isValidEmail(props.enteredEmail)) {
      setCheckEmailEntered('Enter a valid work email');
      return;
    } else if (checkPublicDomain(props.enteredEmail)) {
      setCheckEmailEntered('Enter a valid work email');
      return;
    } else {
      setCheckEmailEntered('')
    }
    checkGuestInfo(props.enteredEmail);
  }


  useEffect(() => {
    let FormEmailAutofill = JSON.parse(localStorage.getItem('subscribeformdetails'));
    if (FormEmailAutofill && typeof FormEmailAutofill === 'object' && Object.keys(FormEmailAutofill).length > 0) {
      props.setEnteredEmail(FormEmailAutofill.email ? FormEmailAutofill.email : FormEmailAutofill.emailId || '');

    }

  }, []);

  const checkGuestInfo = async (emailId) => {
    setIsLoading(true);
    let userIP = "";
    const userLocationDetails = await getUserGeolocationInfo();
    if (userLocationDetails && userLocationDetails.usripaddress) {
      userIP = userLocationDetails.usripaddress;
    }

    if (!Cookies.get("sesEmail") || !Cookies.get("sesUserId")) {
      ICSuserTrack("", "User gives - " + emailId, Url, "CES 2024 Report", "", Cookies.get("accessid"))
    } else {
      ICSuserTrack(Cookies.get("sesEmail"), "User gives - " + emailId, Url, "CES 2024 Report", Cookies.get("sesUserId"), Cookies.get("accessid"))
    }

    const url = process.env.NEXT_PUBLIC_REACT_APP_RDT_SERVICE_URL + '/rdt/cesreport/mailverification';
    const inputObj = {
      type: "CESReport",
      email: emailId,
      ipAddress: userIP,
      reportId: props.reportId || "1"// niharika suggsted to hardcode
    }

    localStorage.setItem("subscribeformdetails", JSON.stringify(inputObj));

    const response = await fetch(url, {
      method: "POST",
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify(inputObj)
    })

    const result = await response.json();

    if (result.status == 'verification code has been sent') {
      props.setProceedForVerification(true);
      setIsLoading(false);
    } else {
      setVerifyError('Something went wrong!, Please try again');
      setIsLoading(false);
    }

  }

  const HandleTalktous = () => {
    if (!Cookies.get("sesEmail") || !Cookies.get("sesUserId")) {
      ICSuserTrack("", "Clicked on talk to us", Url, "CES 2024 Report", "", Cookies.get("accessid"))
    } else {
      ICSuserTrack(Cookies.get("sesEmail"), "Clicked on talk to us", Url, "CES 2024 Report", Cookies.get("sesUserId"), Cookies.get("accessid"))
    }
    props.setShowTalkToUsPopup(true);
  }

  const handleEnteredEmail = (e) => {
    setCheckEmailEntered('');
    props.setEnteredEmail(e.target.value);
  }


  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }

    return () => {
      // Cleanup function to revert the style when the component unmounts
      document.body.style.overflow = 'visible';
    };
  }, [isOpen]);


  return (
    <div>
      {isLoading &&
        <div
          style={{
            position: "absolute",
            zIndex: "1000000000"
          }}
        >
          <Blocker></Blocker>
        </div>
      }
      {verifyError && <ErrorMassage width="70%" message={verifyError} />}
      <ReactModal
        isOpen={isOpen}
        ariaHideApp={false}
        className="modal-popup-Verifymail"
      >
        <div className="closePopup-verify" onClick={() => handleClose()}>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.01689 1.01689C1.34785 0.685932 1.79673 0.5 2.26478 0.5C2.73283 0.5 3.18171 0.685932 3.51267 1.01689L11 8.50422L18.4873 1.01689C18.8183 0.685932 19.2672 0.5 19.7352 0.5C20.2033 0.5 20.6521 0.685932 20.9831 1.01689C21.3141 1.34785 21.5 1.79673 21.5 2.26478C21.5 2.73283 21.3141 3.18171 20.9831 3.51267L13.4958 11L20.9831 18.4873C21.3141 18.8183 21.5 19.2672 21.5 19.7352C21.5 20.2033 21.3141 20.6521 20.9831 20.9831C20.6521 21.3141 20.2033 21.5 19.7352 21.5C19.2672 21.5 18.8183 21.3141 18.4873 20.9831L11 13.4958L3.51267 20.9831C3.18171 21.3141 2.73283 21.5 2.26478 21.5C1.79673 21.5 1.34785 21.3141 1.01689 20.9831C0.685931 20.6521 0.5 20.2033 0.5 19.7352C0.5 19.2672 0.685931 18.8183 1.01689 18.4873L8.50422 11L1.01689 3.51267C0.685931 3.18171 0.5 2.73283 0.5 2.26478C0.5 1.79673 0.685931 1.34785 1.01689 1.01689Z" fill="#D9D9D9" />
          </svg>
        </div>
        <VerifyPopHeader text="Verify Email Address" Img={Email} TickImg={Tick}></VerifyPopHeader>

        {/* EMAIL ADDRESS */}
        {!props.proceedForVerification ? <EmailField value={props.enteredEmail} checkEmailEntered={checkEmailEntered} setEnteredEmail={props.setEnteredEmail} onChange={handleEnteredEmail}></EmailField>
          : <VerifyCode
            directKey={props.directKey}
            timerValue={180}
            setIsLoading={setIsLoading}
            setVerifyError={setVerifyError}
            setVerifySuccess={setVerifySuccess}
            requestType="CESReport"
            reportId={props.reportId}
            emailId={props.enteredEmail}
            setHandleErrorMsgCES={setHandleErrorMsgCES}
            handleErrorMsgCES={handleErrorMsgCES}
            setHandleSuccMsgCES={setHandleSuccMsgCES}
            handleSuccMsgCES={handleSuccMsgCES}
            setVerifiedPayload={props.setVerifiedPayload}
            handleClose={handleClose}
            reportUrl={props.reportUrl}
          ></VerifyCode>}

        {/* BUTTON -- resend code*/}
        {!props.proceedForVerification && <ButtonWrapper>

          <Button variant="solidOrange" text="Proceed" width="190px" height="44px" mbwidth="115px" onClick={handleVerifyEmailProceed}></Button>
        </ButtonWrapper>}

        {/* MESSAGE */}
        {/* <TextWrap>
          <P text="Have issues verifying your email? " color="#000" fontSize="16px" fontWeight="400"></P>
          <TalkUs onClick={() => { HandleTalktous(); props.setShowTalkToUsPopup(true); props.setTalktousIdentifier('PURCHASEREPORT') }}>Talk to us</TalkUs>
        </TextWrap> */}

      </ReactModal>
    </div>
  )
}
